"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
var paramRegex = exports.paramRegex = /\/(:([^\/?]*)\??)/g;
var optionalRegex = exports.optionalRegex = /(\/:[^\/]*\?)$/g;


//////////////////
// WEBPACK FOOTER
// ./node_modules/mobx-router/dist/regex.js
// module id = 1262
// module chunks = 0